module.exports = __webpack_public_path__ + "img/groups.f99caa3a.png";